import { Route } from "react-router"
import { PublicLayout } from "./layout"
import { HomePage } from "./home"
import { AboutPage } from "./about"
import { ProgramsPage } from "./programs"
import { SponsorPage } from "./sponsor"
import { NominatePage } from "./nominate"
import { PartnerSchoolsPage } from "./partner-schools"
import { EventsPage } from "./events"
import { EventDetailPage } from "./event-detail"
import { ContactPage } from "./contact"
import { WomensEmpowermentPage } from "./womens-empowerment"
import { AbilityProgramPage } from "./ability-program"
import { DonorSigninPage } from "./donor-signin"
import { PublicFormPage } from "./public-form"
import { NewsletterUnsubscribePage } from "./newsletter-unsubscribe"

export default (
  <>
    <Route path="donor-signin" element={<DonorSigninPage />} />
    <Route element={<PublicLayout />}>
      <Route index element={<HomePage />} />
      <Route path="about" element={<AboutPage />} />
      <Route path="programs" element={<ProgramsPage />} />
      <Route path="sponsor" element={<SponsorPage />} />
      <Route path="nominate" element={<NominatePage />} />
      <Route path="partner-schools" element={<PartnerSchoolsPage />} />
      <Route path="events" element={<EventsPage />} />
      <Route path="events/:id" element={<EventDetailPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="womens-empowerment" element={<WomensEmpowermentPage />} />
      <Route path="ability-program" element={<AbilityProgramPage />} />
      <Route path="forms/:code" element={<PublicFormPage />} />
      <Route path="newsletter/unsubscribe" element={<NewsletterUnsubscribePage />} />
    </Route>
  </>
)
